import React from "react";
import Grid from "../../GridCards/Grid";
const VentasPadre = () => {
  return <Grid />;
};

export default VentasPadre;
